/* eslint-disable no-param-reassign */
import { getPatchedDataSchema } from '@tencent/data-schema-core';
import { getComponentMethodDeclarations } from "../../../lib/renderer/utils";
import { makeEffectStub } from "../../../lib/utils";
import { highlightRect } from "../../../lib/utils/browser";
import { toRect } from "../../../lib/utils/styling";
import { UICorePlugin } from '../../Plugin';
const windowGlobalStuffs = getPatchedDataSchema({
  type: 'object',
  fields: [{
    id: 'JSON',
    hidden: true,
    description: '提供了 JSON 解析和序列化的能力',
    type: 'object',
    'uc:hideInMonaco': true,
    methods: [{
      id: 'stringify',
      description: '将对象/数组/任意数据，转换为JSON字符串',
      arguments: [{
        id: 'value'
      }]
    }, {
      id: 'parse',
      description: '输入JSON字符串，解析之，并返回对应的对象/数组/数据',
      arguments: [{
        id: 'str'
      }]
    }]
  }, {
    id: 'Date',
    hidden: true,
    type: 'object',
    'uc:hideInMonaco': true,
    methods: [{
      id: 'now',
      arguments: [],
      returnValue: {
        type: 'number',
        description: 'UNIX时间戳（单位毫秒）'
      }
    }, {
      id: 'parse',
      arguments: [{
        id: 'str',
        description: '日期表达式字符串，例如 `"2022-12-31 12:00:30"`'
      }],
      returnValue: {
        type: 'number',
        description: 'UNIX时间戳（单位毫秒）'
      }
    }]
  }, {
    id: 'Math',
    hidden: true,
    type: 'object',
    'uc:hideInMonaco': true,
    methods: [{
      id: 'round',
      title: '四舍五入取整',
      arguments: [{
        id: 'value'
      }]
    }, {
      id: 'random',
      title: '随机数',
      arguments: [],
      description: '返回0～1之间的随机小数'
    }, {
      id: 'floor',
      title: '向下取整',
      arguments: [{
        id: 'value'
      }]
    }, {
      id: 'ceil',
      title: '向上取整',
      arguments: [{
        id: 'value'
      }]
    }, {
      id: 'max',
      arguments: [{
        id: '...values'
      }]
    }, {
      id: 'min',
      arguments: [{
        id: '...values'
      }]
    }, {
      id: 'abs',
      arguments: [{
        id: 'value'
      }]
    }]
  }, {
    id: 'console',
    hidden: true,
    type: 'object',
    description: '在浏览器的 DevTools 里输出一些东西',
    'uc:hideInMonaco': true,
    methods: [{
      id: 'log',
      arguments: [{
        id: '...values'
      }]
    }, {
      id: 'error',
      arguments: [{
        id: '...values'
      }]
    }, {
      id: 'warn',
      arguments: [{
        id: 'value'
      }]
    }]
  }]
}).fields;
export class FakeDataSourcesPlugin extends UICorePlugin {
  install(uc) {
    const isDesignMode = !!uc.isDesignMode;
    // 这个插件可以用于设计模式，为 CRenderer 注册一些诸如 `console` `Math` `$refs` 之类的 “数据源”
    // 可以让自动补全体验更好一些
    uc.hooks.pageletRendererCreated.tap('FakeDataSourcesPlugin', renderer => {
      renderer.$once('hook:mounted', () => {
        // 注册那些全局的东西
        windowGlobalStuffs.forEach(schema => {
          const id = schema.id;
          renderer[id] = window[id];
          // 设计模式下，需要自动补全信息
          if (isDesignMode) renderer.addDataSourceDeclaration({
            id,
            schema
          });
        });
      });
      if (isDesignMode) {
        const handleAutoCompleteRef = (action, schema) => {
          if (action === 'active') {
            const inst = renderer.$refs[schema.id];
            if (!inst) return;
            if (Array.isArray(inst)) return;
            highlightRect(toRect(inst));
          }
        };
        const injectRefs = makeEffectStub(() => {
          const refNames = Object.keys(renderer.$refs).sort();
          const descFor$refs = '**⚠️注意** 只能在“事件行为”里使用，其他地方会导致 **页面出错**！';
          renderer.addDataSourceDeclaration({
            id: '$refs',
            schema: {
              hidden: true,
              title: '组件实例',
              description: descFor$refs,
              type: 'object',
              fields: refNames.map(id => {
                var _instance$$vnode;
                const instance = renderer.$refs[id];
                const factory = instance === null || instance === void 0 || (_instance$$vnode = instance.$vnode) === null || _instance$$vnode === void 0 || (_instance$$vnode = _instance$$vnode.data) === null || _instance$$vnode === void 0 ? void 0 : _instance$$vnode['uc:VNodeFactory'];
                const ans = {
                  id,
                  type: 'object',
                  methods: [],
                  fields: [],
                  'uc:handleAutoComplete': handleAutoCompleteRef,
                  description: descFor$refs + '\n\n@uicore component_ref:' + id
                };
                if (factory) {
                  ans.methods.push(...getComponentMethodDeclarations(renderer, factory.compPath));
                }
                // 私有属性太辣眼睛了，暂时不显示出来
                // // eslint-disable-next-line no-underscore-dangle
                // if (instance && instance._isVue) {
                //   Object.keys(instance.$data).forEach((id) => {
                //     ans.fields!.push({ id });
                //   });
                //   Object.keys(instance.$options?.computed || {}).forEach((id) => {
                //     ans.fields!.push({ id });
                //   });
                // }
                return ans;
              })
            }
          });
        });
        const sync = () => injectRefs([String(Object.keys(renderer.$refs).sort()), renderer.ucPagelet, uc.components]);
        sync();
        renderer.$on('hook:updated', sync);
      }
    });
  }
}